import React, { useEffect, useRef } from "react";
import "./All_Solutions.css";

const All_Solutions = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("active");
        } else {
          sectionRef.current.classList.remove("active");
        }
      },
      {
        threshold: 0.5,
      },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
  return (
    <section className="All_Solutions">
      <div className="All_Solutions_div" ref={sectionRef}>
        <div className="all_solutions_title_holder">
          <h2 className="all_solutions_title">One Platform. All Solutions.</h2>
        </div>

        <div className="all_solutions_banner_holder">
          <div className="all_Solutions_image_holder">
            <img
              src="/assets/images/home/all_solutions/all-solutions.png"
              alt="all-solution"
              className="all_solutions_img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default All_Solutions;
